const fontStacks = {
  sans: '"Inter Variable", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  monospace: '"Amazon Ember Monospace", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
} as const;

export default fontStacks;
